import { Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePageMeta } from "@/hooks/usePageMeta";
import { BackToHomeLink } from "@/components/BackToHomeLink";
import { useLocale } from "@/hooks/useLocale";

export default function Contact() {
  const { locale, pathInLocale, strings } = useLocale();

  usePageMeta({
    title: strings.contact.title,
    description: "Get in touch with the FreeDailyPro team.",
    path: pathInLocale(locale),
    localized: true,
  });

  return (
    <div className="container max-w-2xl mx-auto py-12 px-4">
      <BackToHomeLink />
      <h1 className="text-3xl font-bold mb-2">{strings.contact.title}</h1>
      <p className="text-sm text-muted-foreground mb-8">{strings.contact.subtitle}</p>

      <div className="p-6 rounded-xl border border-border bg-card space-y-6">
        <div className="flex items-start gap-3">
          <Mail className="h-5 w-5 text-primary mt-0.5" />
          <div>
            <p className="font-medium text-sm">{strings.contact.email}</p>
            <a
              href="mailto:support@freedailypro.com"
              className="text-sm text-primary underline"
            >
              support@freedailypro.com
            </a>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Clock className="h-5 w-5 text-primary mt-0.5" />
          <div>
            <p className="font-medium text-sm">{strings.contact.responseTime}</p>
            <p className="text-sm text-muted-foreground">
              {strings.contact.responseTimeValue}
            </p>
          </div>
        </div>

        <Button asChild className="w-full">
          <a href="mailto:support@freedailypro.com">{strings.contact.sendEmail}</a>
        </Button>
      </div>

      <p className="text-xs text-muted-foreground mt-6 text-center">
        {strings.contact.billingNote}
      </p>

      <div className="mt-10 space-y-6">
        <div>
          <h2 className="text-lg font-semibold mb-2">{strings.contact.whoWeAreTitle}</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{strings.contact.whoWeAreBody}</p>
        </div>
        <div>
          <h2 className="text-lg font-semibold mb-2">{strings.contact.whatWeSupportTitle}</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">{strings.contact.whatWeSupportBody}</p>
        </div>
      </div>
    </div>
  );
}
